//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import AddCard from "@/components/management/homeCard/AddCard";
import EditCard from "@/components/management/homeCard/EditCard";
export default {
  name: "HomeCard",
  components: {
    Sift: Sift,
    AddCard: AddCard,
    EditCard: EditCard
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.fetchSiftData();
  },
  destroyed: function destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true;
      this.siftData = [{
        type: "text",
        key: "cardName",
        label: "卡片名称",
        placeholder: "",
        default: ""
      }, {
        type: "text",
        key: "cardCode",
        label: "卡片代码",
        placeholder: "",
        default: ""
      }];
      this.loading = false;
      this.$nextTick(function () {
        _this.initPage();
      });
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      this.loading = true;
      var data = {
        cardName: this.$refs.needSift.getValue().cardName,
        cardCode: this.$refs.needSift.getValue().cardCode,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$http.get(this.$base.menhuUrl + "/tabCardInfo/findPage", {
        params: data
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this2.list = data.resData.records;
        }

        _this2.total = data.resData.total;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 添加
    addFn: function addFn() {
      this.$refs.addCardDialog.dialogShow("");
    },
    // 删除
    deleteFn: function deleteFn(data) {
      var _this3 = this;

      this.$confirm("是否确定删除 " + data.card_name + " 卡片?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.loading = true; // 删除接口

        _this3.$http.delete(_this3.$base.menhuUrl + "/tabCardInfo/remove", {
          params: {
            cardId: data.card_id
          }
        }).then(function (_ref2) {
          var data = _ref2.data;

          if (data.resCode === 0) {
            _this3.$message.success(data.resMsg);

            _this3.initPage();
          }

          _this3.loading = false;
        }).catch(function () {
          _this3.loading = false;
        });
      }).catch(function () {
        _this3.$message.info("已取消删除");
      });
    },
    // 详情
    editFn: function editFn(item) {
      this.$refs.editCardDialog.dialogShow(item);
    },
    // 默认页面数据
    initPage: function initPage() {
      this.pageNum = 1;
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};